<script setup>
import { ref, onErrorCaptured } from 'vue';
import { useI18n } from 'vue-i18n';
import Widget from 'dashboard/modules/widget-preview/components/Widget.vue';
import InputRadioGroup from './InputRadioGroup.vue';

defineProps({
  isWidgetPreview: {
    type: Boolean,
    default: true,
  },
  widgetViewOptions: {
    type: Array,
    required: true,
  },
  welcomeHeading: {
    type: String,
    default: '',
  },
  welcomeTagline: {
    type: String,
    default: '',
  },
  websiteName: {
    type: String,
    default: '',
  },
  avatarUrl: {
    type: String,
    default: '',
  },
  headerBackgroundUrl: {
    type: String,
    default: '',
  },
  headerDisplayType: {
    type: String,
    default: 'avatar',
  },
  headerTextColor: {
    type: String,
    default: '#FFFFFF',
  },
  replyTime: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  widgetBubblePosition: {
    type: String,
    default: 'right',
  },
  widgetBubbleLauncherTitle: {
    type: String,
    default: '',
  },
  widgetBubbleType: {
    type: String,
    default: 'standard',
  },
  widgetScript: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['widgetViewChange']);

const { t } = useI18n();

const previewFailed = ref(false);

onErrorCaptured(() => {
  previewFailed.value = true;
  return false;
});

const onWidgetViewChange = item => {
  emit('widgetViewChange', item);
};
</script>

<template>
  <div
    class="w-full min-w-0 flex-1 overflow-x-hidden lg:flex lg:h-full lg:min-h-0 lg:w-3/5 lg:flex-col lg:overflow-y-hidden"
  >
    <InputRadioGroup
      name="widget-view-options"
      class="text-center"
      :items="widgetViewOptions"
      :action="onWidgetViewChange"
    />
    <div
      v-if="previewFailed"
      class="mx-5 mb-5 rounded-lg bg-n-slate-3 p-4 text-sm text-n-slate-11 dark:bg-n-solid-3"
    >
      {{ t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.PREVIEW_LOAD_ERROR') }}
    </div>
    <template v-else>
      <div
        v-if="isWidgetPreview"
        class="mx-5 mb-5 flex min-h-[40.625rem] max-w-full flex-col items-center justify-end overflow-x-hidden overflow-y-hidden rounded-lg bg-n-slate-3 p-2.5 lg:min-h-0 lg:flex-1"
      >
        <Widget
          :welcome-heading="welcomeHeading"
          :welcome-tagline="welcomeTagline"
          :website-name="websiteName || ' '"
          :logo="avatarUrl"
          :header-background-url="headerBackgroundUrl"
          :header-display-type="headerDisplayType"
          :header-text-color="headerTextColor"
          is-online
          :reply-time="replyTime"
          :color="color"
          :widget-bubble-position="widgetBubblePosition"
          :widget-bubble-launcher-title="widgetBubbleLauncherTitle"
          :widget-bubble-type="widgetBubbleType"
        />
      </div>
      <div
        v-else
        class="mx-5 max-w-full overflow-x-hidden overflow-y-hidden rounded-lg bg-n-slate-3 p-2.5 dark:bg-n-solid-3 lg:min-h-0 lg:flex-1"
      >
        <woot-code :script="widgetScript" />
      </div>
    </template>
  </div>
</template>
